import { render } from "./OnboardingProvider.vue?vue&type=template&id=ef41fa12"
import script from "./OnboardingProvider.vue?vue&type=script&lang=js"
export * from "./OnboardingProvider.vue?vue&type=script&lang=js"

import "./OnboardingProvider.vue?vue&type=style&index=0&id=ef41fa12&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__